<template>
  <div class="container last-page loser">
    <div class="content">
      <div class="header">
        <p>Stap 3 / 3</p>
        <h1><strong>Helaas…<br/>Je hebt niet gewonnen…</strong></h1>
      </div>
      <div class="group">
        <span class="emoji">😥</span>
        <p>Bedankt voor uw bezoek aan onze stand,<br/>en hopelijk tot een volgende keer!</p>
        <ck-progressbar class="small" :max="maxSeconds" :value="secondsLeft" />
      </div>
      <div class="group">
        <p>Het Quality Guard Team</p>
        <img class="img-logo" alt="Logo Quality Guard" src="~@/assets/images/logo-white.png">
      </div>
    </div>
  </div>
</template>

<script>
import timerPage from "@/mixins/timer_page";

export default {
    mixins: [timerPage]
};
</script>
